angular.module('property-price-list')
    .controller('PropertyPriceListShowController', function ($window, $rootScope, $state, toastr, data, Project, PropertyService, ProjectService) {
        this.item = data;
        this.PropertyService = PropertyService;
        this.ProjectService = ProjectService;

        this.cancel = () => $window.history.back()
    })
